export default __webpack_public_path__ + "static/media/20.6c6ff940.jpg";